module.exports = __webpack_public_path__ + "img/line.65c466a9.svg";